import { Chapter, SectionTitle, Reveal } from "./Reveal";

const PRODUCERS = [
  {
    product: "Formaggi a latte crudo",
    producer: "Caseificio La Saba",
    place: "Maremma",
  },
  {
    product: "Formaggi del territorio",
    producer: "Caseificio Paterno",
    place: "Maremma",
  },
  {
    product: "La Riserva del Fondatore",
    producer: "Il Fiorino",
    place: "Roccalbegna",
  },
  {
    product: "Salame Bastardo Maremmano",
    producer: "Salumificio Franchi",
    place: "Follonica",
  },
  {
    product: "Olio extravergine di oliva",
    producer: "Giannoni Barbara",
    place: "Scansano",
  },
  {
    product: "Salumi della tradizione",
    producer: "Salumificio Patrone",
    place: "Maremma",
  },
];

const Eccellenze = () => (
  <section id="eccellenze" data-testid="eccellenze-section" className="relative py-24 sm:py-36 bg-[#141210]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter number="04" title="Le Eccellenze" />
      <SectionTitle className="max-w-3xl">
        Chi produce per noi
        <span className="italic text-[#C5A059]"> è nostro vicino.</span>
      </SectionTitle>
      <Reveal delay={0.15}>
        <p className="mt-8 text-base sm:text-lg text-[#C5BCAD] leading-relaxed max-w-2xl">
          La regola dei vini vale anche in cucina: formaggi, salumi e olio arrivano
          da produttori del territorio che conosciamo per nome. Sono loro la prima
          firma di ogni piatto.
        </p>
      </Reveal>

      <Reveal delay={0.2} className="mt-14">
        <div className="grid sm:grid-cols-2 gap-5">
          <figure className="group relative overflow-hidden border border-[#C5A059]/20">
            <img
              src="/img/g-formaggi.jpg"
              alt="Selezione di formaggi a latte crudo dei caseifici di Maremma"
              loading="lazy"
              className="w-full aspect-[16/10] object-cover group-hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
            <figcaption className="absolute bottom-3 left-3 text-[10px] uppercase tracking-[0.3em] text-[#C5A059] bg-[#0D0C0B]/75 backdrop-blur px-3 py-1.5">
              I Formaggi
            </figcaption>
          </figure>
          <figure className="group relative overflow-hidden border border-[#C5A059]/20">
            <img
              src="/img/g-salumi.jpg"
              alt="Tagliere di salumi toscani dei salumifici locali"
              loading="lazy"
              className="w-full aspect-[16/10] object-cover group-hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
            <figcaption className="absolute bottom-3 left-3 text-[10px] uppercase tracking-[0.3em] text-[#C5A059] bg-[#0D0C0B]/75 backdrop-blur px-3 py-1.5">
              I Salumi
            </figcaption>
          </figure>
        </div>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-x-14">
        {PRODUCERS.map((p, i) => (
          <Reveal key={p.producer} delay={(i % 2) * 0.08}>
            <div
              data-testid={`producer-${i}`}
              className="group flex items-baseline gap-5 py-6 border-b border-[#F7F4EE]/10 hover:border-[#C5A059]/40 transition-colors duration-300"
            >
              <span className="font-cinzel text-sm text-[#C5A059]/70 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0">
                <h3 className="font-display text-xl sm:text-2xl text-[#F7F4EE] group-hover:text-[#C5A059] transition-colors duration-300">
                  {p.product}
                </h3>
                <p className="mt-1.5 text-[11px] uppercase tracking-[0.22em] text-[#C5BCAD]/75">
                  {p.producer} · {p.place}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Eccellenze;
